/* eslint-disable no-mixed-spaces-and-tabs */
import DoDisturbOutlinedIcon from "@mui/icons-material/DoDisturbOutlined";
import GroupsIcon from "@mui/icons-material/Groups";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import { Stack } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import {
	HOURS_COMPLETED,
	NO_CALL_NO_SHOWS,
	WORKER_CANCELLATIONS,
	// eslint-disable-next-line sort-imports
	WORKERS_WITH_ATLEAST_1_SHIFT,
	WORKERS_WITH_NO_SHIFTS,
} from "../../../../../assets/constants";
import { useWorkerActivityData } from "../../../controllers/use-worker-activity-data";
import ActivityKpiCard from "../activity-kpi-card";

interface KpiSummariesProps {
	selectedKPI: string;
	setSelectedKPI: (kpi: string) => void;
	KPICount: any;
}

const KpiSummaries: React.FC<KpiSummariesProps> = ({
	selectedKPI,
	setSelectedKPI,
	KPICount,
}) => {
	const { dailyActivityReportStatus } = useWorkerActivityData();
	const { t } = useTranslation();

	const handleClick = (kpi: string) => {
		setSelectedKPI(kpi === selectedKPI ? "ALL" : kpi);
	};

	const commonProps = {
		loading: dailyActivityReportStatus,
		handleClick,
	};
	return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      sx={{ flexWrap: "nowrap", overflowX: "auto" }}
      pt={2}
      pb={1}
      pl={1}
    >
      <ActivityKpiCard
        {...commonProps}
        icon={<GroupsIcon />}
        iconBackgroundColor="#E8F5E9"
        iconColor="#26A69A"
        kpiDataCount={KPICount[WORKERS_WITH_ATLEAST_1_SHIFT].count}
        title={t("worker-activity_kpi-workers-with-shift")}
        subTitle={t("worker-activity_percent-of-workers", {
          percentage: KPICount[WORKERS_WITH_ATLEAST_1_SHIFT].percentage,
        })}
        isToggled={selectedKPI === "WORKERS WITH AT LEAST 1 SHIFT"}
        kpiData="WORKERS WITH AT LEAST 1 SHIFT"
      />
      <ActivityKpiCard
        icon={<GroupsIcon />}
        iconBackgroundColor={"#F9DEDC"}
        iconColor={"#E44B48"}
        kpiDataCount={KPICount[WORKERS_WITH_NO_SHIFTS].count}
        title={t("worker-activity_kpi-workers-no-shifts")}
        subTitle={t("worker-activity_percent-of-workers", {
          percentage: KPICount[WORKERS_WITH_NO_SHIFTS].percentage,
        })}
        isToggled={selectedKPI === "WORKERS WITH NO SHIFTS"}
        kpiData={"WORKERS WITH NO SHIFTS"}
        {...commonProps}
      />
      <ActivityKpiCard
        icon={<DoDisturbOutlinedIcon />}
        iconBackgroundColor={"#F9DEDC"}
        iconColor={"#E44B48"}
        kpiDataCount={KPICount[WORKER_CANCELLATIONS].count}
        title={t("worker-activity_kpi-worker-cancellations")}
        subTitle={t("worker-activity_percent-of-shifts", {
          percentage: KPICount[WORKER_CANCELLATIONS].percentage,
        })}
        isToggled={selectedKPI === "WORKER CANCELLATIONS"}
        kpiData={WORKER_CANCELLATIONS}
        {...commonProps}
      />
      <ActivityKpiCard
        icon={<PersonOffIcon />}
        iconBackgroundColor={"#F9DEDC"}
        iconColor={"#E44B48"}
        kpiDataCount={KPICount[NO_CALL_NO_SHOWS].count}
        title={t("worker-activity_kpi-no-call-no-shows")}
        subTitle={t("worker-activity_percent-of-shifts", {
          percentage: KPICount[NO_CALL_NO_SHOWS].percentage,
        })}
        isToggled={selectedKPI === "NO CALL NO SHOWS"}
        kpiData={"NO CALL NO SHOWS"}
        {...commonProps}
      />
    </Stack>
  );
};

export default React.memo(KpiSummaries);
